import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "Inicio", section: "inicio" },
  { label: "¿Por qué elegir Autofinanza?", section: "por-que" },
  { label: "Cómo funciona", section: "como-funciona" },
  { label: "Preguntas frecuentes", section: "faq" },
  { label: "Ya tengo un trámite", route: "/reingreso", id: "reingreso" },
  { label: "Acceso staff", route: "/staff/login", id: "staff" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (link) => {
    setOpen(false);
    if (link.route) {
      navigate(link.route);
      return;
    }
    if (location.pathname !== "/") {
      navigate("/#" + link.section);
    } else {
      const el = document.getElementById(link.section);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 transition-colors duration-300"
      style={{
        background: scrolled ? "rgba(13,13,13,0.92)" : "rgba(13,13,13,0.65)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid var(--af-border-dark)",
      }}
    >
      <div className="af-container flex items-center justify-between" style={{ height: 72 }}>
        <button
          data-testid="nav-logo-home"
          onClick={() => go({ section: "inicio" })}
          className="flex items-center shrink-0"
          style={{ marginRight: 32 }}
          aria-label="Autofinanza inicio"
        >
          <Logo height={46} />
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center" style={{ gap: 30 }}>
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.id || l.section || "tramite"}`}
              onClick={() => go(l)}
              className="text-[15px] text-white/90 hover:text-af-orange-core transition-colors duration-200 whitespace-nowrap"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-iniciar-proceso"
            onClick={() => navigate("/registro")}
            className="af-btn-primary"
            style={{ padding: "0.6rem 1.3rem", fontSize: "0.98rem" }}
          >
            Iniciar proceso
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menú"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden af-container pb-6 pt-2 flex flex-col gap-1"
          style={{ background: "rgba(13,13,13,0.98)", borderTop: "1px solid var(--af-border-dark)" }}>
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-mobile-${l.id || l.section || "tramite"}`}
              onClick={() => go(l)}
              className="text-left text-white/90 hover:text-af-orange-core py-3 border-b border-af-border-dark"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-iniciar"
            onClick={() => { setOpen(false); navigate("/registro"); }}
            className="af-btn-primary mt-4 w-full"
          >
            Iniciar proceso
          </button>
        </div>
      )}
    </header>
  );
}
